import React, { useRef, useEffect, useState } from "react";

export type IMenuOption = {
  label: string;
  onClick?: (...args: any[]) => void;
  children?: IMenuOption[];
  startIcon?: string;
  endIcon?: string;
  isDisabled?: boolean;
  startIconEle?: React.ReactNode;
  endIconEle?: React.ReactNode;
  isSelected?: boolean;
  menuItemStyle?: React.CSSProperties;
};

interface IProps {
  options: IMenuOption[];
  isOpen: boolean;
  onClose: () => void;
  anchorRef: React.RefObject<HTMLElement | HTMLButtonElement> | null;
  level?: number;
  containerStyles?: React.CSSProperties;
  onMenuOptionClick?: (...args: any[]) => void;
}

export const MenuDropdown: React.FC<IProps> = ({
  options,
  isOpen,
  onClose,
  anchorRef,
  level = 0,
  containerStyles,
  onMenuOptionClick,
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleMenuItemClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    option: IMenuOption,
    index: number,
    levelItem: number
  ) => {
    if (option?.isDisabled) return;
    e.stopPropagation();

    if (option?.onClick) {
      option.onClick(e, option, index, levelItem);
    } else if (onMenuOptionClick) {
      onMenuOptionClick(e, option, index, levelItem);
    } else if (levelItem === 0) {
      setSelectedIndex((prev) => (typeof prev === "number" ? null : index));
    }
  };

  useEffect(() => {
    // Click outside handler
    const handleClickOutside = (event: MouseEvent) => {
        console.log({menuRef, anchorRef})
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        anchorRef?.current &&
        !anchorRef.current?.contains(event.target as Node)
      ) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchorRef, isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="rec_header_dropdown_menu_wrapper"
      ref={menuRef}
      style={{
        position: "absolute",
        top: level === 0 ? "100%" : 0,
        left: level === 0 ? 0 : "101%",
        zIndex: 1000 + level,
        width: "fit-content",
        ...containerStyles,
      }}
    >
      {options.map((option, index) => (
        <div
          key={index}
          className={`rec_header_dropdown_menu_item ${
            option?.isDisabled ? "disabled" : ""
          } ${option?.isSelected ? "selected" : ""}`}
          onClick={(e) => handleMenuItemClick(e, option, index, level)}
          style={{ ...option?.menuItemStyle }}
        >
          <div className="rec_header_dropdown_menu_item child">
            <div className="rec_header_dropdown_menu_item_subChild">
              {/* Start Icon  */}
              {option.startIcon ? (
                <div className={option.startIcon} />
              ) : option.startIconEle ? (
                option.startIconEle
              ) : null}

              <span>{option.label}</span>
            </div>

            {/* End Icon  */}
            {option.endIcon ? (
              <div className={option.endIcon} />
            ) : option.endIconEle ? (
              option.endIconEle
            ) : null}
          </div>

          {/* For Sub Menu  */}
          {option.children && (
            <MenuDropdown
              options={option.children}
              isOpen={selectedIndex === index}
              onClose={onClose}
              anchorRef={menuRef}
              level={level + 1}
            />
          )}
        </div>
      ))}
    </div>
  );
};
